import '@backstage/ui/css/styles.css';
import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
